<div class="left-side">
	<button mat-icon-button type="button" class="menu-toggle" (click)="toggleSidebar()">
		<mat-icon aria-label="Menu" svgIcon="burger" />
	</button>

	<au-breadcrumbs />
</div>

<topbar-action-buttons />
